import { render, staticRenderFns } from "./textareabasic.vue?vue&type=template&id=9d36b506&scoped=true"
import script from "./textareabasic.vue?vue&type=script&lang=js"
export * from "./textareabasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d36b506",
  null
  
)

export default component.exports